import { graphql } from "@/gql";

export const blogPostStatusCountsQuery = graphql(`
  query BlogPostStatusCounts {
    all: blogPosts(first: 1) {
      paginatorInfo {
        total
      }
    }
    published: blogPosts(first: 1, status: PUBLISHED) {
      paginatorInfo {
        total
      }
    }
    draft: blogPosts(first: 1, status: DRAFT) {
      paginatorInfo {
        total
      }
    }
  }
`);
